"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _ethers = require("ethers"),
    _token = require("./lib/token"),
    _formatBN = require("./lib/formatBN"),
    _default = function _default(provider) {
  return (
    /*#__PURE__*/

    /**
    * Format token amounts taking decimals into account
    *
    * @param {string} tokenAddress The address of the token
    * @param {*} amount The absolute amount for the token quantity (wei)
    * @param {bool} showSymbol Whether the token symbol will be printed after the amount
    * @param {*} precision The number of decimal places to format to. If set, the precision is always enforced.
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tokenAddress, amount) {
        var showSymbol,
            precision,
            amountBn,
            fixed,
            decimals,
            symbol,
            token,
            formattedAmount,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                showSymbol = _args.length > 2 && _args[2] !== undefined ? _args[2] : !0;
                precision = _args.length > 3 ? _args[3] : undefined;
                amountBn = _ethers.BigNumber.from(amount), fixed = !!precision;

                if (!(tokenAddress === _token.ETH)) {
                  _context.next = 7;
                  break;
                }

                decimals = _ethers.BigNumber.from(18), showSymbol && (symbol = "ETH");
                _context.next = 33;
                break;

              case 7:
                token = new _ethers.ethers.Contract(tokenAddress, _token.ERC20_SYMBOL_DECIMALS_ABI, provider);
                _context.t0 = _ethers.BigNumber;
                _context.next = 11;
                return token.decimals();

              case 11:
                _context.t1 = _context.sent;
                decimals = _context.t0.from.call(_context.t0, _context.t1);

                if (!showSymbol) {
                  _context.next = 33;
                  break;
                }

                _context.prev = 14;
                _context.next = 17;
                return token.symbol();

              case 17:
                _context.t2 = _context.sent;

                if (_context.t2) {
                  _context.next = 20;
                  break;
                }

                _context.t2 = "";

              case 20:
                symbol = _context.t2;
                _context.next = 33;
                break;

              case 23:
                _context.prev = 23;
                _context.t3 = _context["catch"](14);
                token = new _ethers.ethers.Contract(tokenAddress, _token.ERC20_SYMBOL_BYTES32_ABI, provider);
                _context.next = 28;
                return token.symbol();

              case 28:
                _context.t4 = _context.sent;

                if (_context.t4) {
                  _context.next = 31;
                  break;
                }

                _context.t4 = "";

              case 31:
                symbol = _context.t4;
                symbol = symbol && _ethers.ethers.utils.toUtf8String(symbol);

              case 33:
                precision = precision || decimals;
                formattedAmount = (0, _formatBN.formatBN)(amountBn, (0, _formatBN.tenPow)(decimals), +precision, fixed);
                return _context.abrupt("return", {
                  type: "string",
                  value: showSymbol ? "".concat(formattedAmount, " ").concat(symbol) : formattedAmount
                });

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[14, 23]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;